import { DefaultLoader, Loadable } from 'excalibur';

export const loadResources = (loader: DefaultLoader, ...resourceGroups: Array<Record<string, Loadable<any>>>) => {
    for (const resourceGroup of resourceGroups) {
        for (const resource of Object.values(resourceGroup)) {
            loader.addResource(resource);
        }
    }
};
